import React, {FunctionComponent, DetailedHTMLProps} from "react";

interface CheckboxProps extends DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  className?: string;
  inline?: boolean;
  label?: string;
  name: string;
}

const Checkbox: FunctionComponent<CheckboxProps> = ({className, inline, label, name, ...rest}) => {
  return (
    <div className={`flex ${
        inline ? 'flex-row items-baseline' : 'flex-col'
      }${
        className ? ' ' + className : ''
      }`}>
      <input 
        id={name}
        className='checkbox__input bg-transparent block mx-2 py-2'
        name={name}
        type='checkbox'
        {...rest}
      />
      {
        label &&
        <label
          className='mb-1 pl-2 text-gray-600'
          htmlFor={name}
        >{label}</label>
      }
    </div>
  )
}

export default Checkbox;
